import { ensureRouteData } from '@/app/query-client'
import { courseDetailQueryOptions } from '@/features/courses/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { parseId } from '@/screens/courses/lib/params'

/**
 * The `/courses/$courseId/lectures/$lectureId` loader.
 *
 * MAIN: the COURSE, not the lecture — mm-be has no single-lecture read, and
 * the player needs the whole list anyway (the side list, previous / next,
 * the course's `purchased`). The lecture is found in it by id; one that is
 * not there is the screen's not-found state. Moving lecture to lecture keeps
 * the same cache entry, so it is instant.
 *
 * Either id not a positive integer: no request, the screen renders
 * not-found.
 */
export async function loadLecture({
  context: { queryClient },
  params,
}: {
  context: RouterContext
  params: { courseId: string; lectureId: string }
}): Promise<void> {
  const courseId = parseId(params.courseId)
  if (courseId === null || parseId(params.lectureId) === null) return
  await ensureRouteData(queryClient, courseDetailQueryOptions(courseId))
}
